module.exports = __webpack_public_path__ + "media/images/flags/64/US-Virgin-Islands-0ff2537f8d3011a842c0e8b46f44669d.png";